module.exports = __webpack_public_path__ + "static/media/adithya_paramasivam.2868fffd.jpeg";